import { Box, BoxProps, Divider, Drawer, IconButton, List, ListItem, Typography, styled } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { IList } from "../../cms/interfaces/IList";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";

interface Props {
    open: boolean,
    toggleMenu: () => void,
    navigationList?: IList
}

const StyledDrawerHeader = styled(Box)<BoxProps>(({theme}) => ({
    background: theme?.palette?.primary?.light,
    padding: '1em',
    textAlign: 'right'
}));

const DrawerMenu : React.FC<Props> = ({open, toggleMenu, navigationList}) => {
    const {t} = useTranslation("common");

    const onChangeLanguage = (language: ("de" | "en")) => {
        const currentPath = window?.location?.pathname;
        if(!currentPath?.startsWith(`/${language}`)) {
            const linkTags = document.getElementsByTagName("link") as HTMLCollection;
            for(let i = 0; i < linkTags?.length; i++) {
                const tagAttributes = linkTags?.item(i)?.attributes;
                let isAlternateTag = false;
                let href = undefined as string | undefined;
                if(tagAttributes) {
                    for(let a = 0; a < tagAttributes.length; a++) {
                        const attrName = tagAttributes?.item(a)?.name;
                        const attrValue = tagAttributes?.item(a)?.value;
                        if(attrName === "rel" && attrValue === "alternate") {
                            isAlternateTag = true;
                        }
                        if(attrName === "href") {
                            href = attrValue;
                        }
                    }
                }

                if(isAlternateTag && !!href) {
                    i = linkTags?.length;
                    window.location.href = href;
                    return;
                }
            }
        }
    }

    return <Drawer open={open} onClose={toggleMenu} sx={{"& .MuiPaper-root": {width: '90%', maxWidth: '20em', background: '#fff'}}} anchor="right">
        <Box role="presentation">
            <StyledDrawerHeader>
                <Typography variant="caption">{t("common.drawer.title")}</Typography>
            </StyledDrawerHeader>
            <nav>
                <List>
                    {navigationList?.listitems?.map(item => <ListItem>
                        <Link to={item?.pageRef?.relativeUrl??'#'} onClick={() => toggleMenu()}>{item?.text}</Link>
                    </ListItem>)}
                </List>
                <Divider />
                <Box sx={{display: 'flex', justifyContent: 'right'}}>
                    <Box>
                        <IconButton>
                            <ReactCountryFlag className="emojiFlag" svg countryCode="DE" onClick={() => {
                                onChangeLanguage("de");
                            }} />
                        </IconButton>
                    </Box>
                    <Box>
                        <IconButton>
                            <ReactCountryFlag className="emojiFlag" svg countryCode="GB" onClick={() => {
                                onChangeLanguage("en");
                            }} />
                        </IconButton>
                    </Box>
                </Box>
            </nav>
        </Box>
    </Drawer>
}

export default DrawerMenu;